

































import { Session } from '../../../utils/Session';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DailyReportServiceExt } from '../../../biz/DailyReportServiceExt';
import { MessageDialog } from '../../../utils/MessageDialog';
import StarRating from 'vue-star-rating';

@Component({ components: { StarRating } })
export default class EvaluationSection extends Vue {
  @Prop({ required: true, default: '' })
  private user_type!: string;

  @Prop({ required: true, default: 0 })
  private class_id!: number;

  @Prop({ required: true, default: 0 })
  private evaluation!: number;

  private input_evaluation = 5;

  get isStudent() {
    return this.user_type === 'stu';
  }
  get isAdmin() {
    return this.user_type === 'adm';
  }

  get isCo() {
    return Session.isCircleOBuilding();
  }
  async sendEval() {
    const biz = new DailyReportServiceExt();
    await biz.saveEvaluation(this.class_id, this.input_evaluation);
    await MessageDialog.alert('評価を保存しました');
    this.$emit('send', this.input_evaluation);
  }
}
